class RegistrationForm {
  constructor(formSelector) {
    this.form = document.querySelector(formSelector);
    this.codes;
    this.isSubmitting = false;

    if (!this.form) throw new Error(`Form element ${formSelector} not found.`);
    this.initElements();
    this.initFields();
    this.initSearchParams();
    this.initFormSubmit();
  }

  initElements() {
    this.registrationFormBtn = document.getElementById('registration-form-submit');
    this.originalButtonText = this.registrationFormBtn.textContent;
    this.firstNameError = this.form.querySelector('.first-name-error');
    this.lastNameError = this.form.querySelector('.last-name-error');
    this.jobTitleError = this.form.querySelector('.job-title-error');
    this.employerError = this.form.querySelector('.employer-error');
    this.phoneError = this.form.querySelector('.phone-error');
    this.regionError = this.form.querySelector('.region-error');
    this.emailError = this.form.querySelector('.email-error');
    this.codeError = this.form.querySelector('.code-error-error');
  }

  initFields() {
    this.fields = [
      { name: 'first-name', field: this.form.elements['first-name'], validation: 'length' },
      { name: 'last-name', field: this.form.elements['last-name'], validation: 'length' },
      { name: 'employer', field: this.form.elements['employer'], validation: 'length' },
      { name: 'job-title', field: this.form.elements['job-title'], validation: 'length' },
      { name: 'region', field: this.form.elements['region'], validation: 'length' },
      { name: 'phone', field: this.form.elements['phone'], validation: 'length' },
      { name: 'email', field: this.form.elements['email'], validation: 'length' },
      { name: 'legal', field: this.form.elements['legal'], validation: 'checked' },
    ];

    this.isValid = {
      'first-name': false,
      'last-name': false,
      employer: false,
      'job-title': false,
      region: false,
      email: false,
      phone: false,
      legal: false,
    };

    this.fields.forEach((f) => {
      f.field.addEventListener('change', () => this.handleFieldChange(f));
      f.field.addEventListener('focus', () => f.field.classList.remove('invalid'));
    });
  }

  handleFieldChange(f) {
    if (f.validation === 'length') {
      this.isValid[f.name] = f.field.value.length > 0;
    }
    if (f.validation === 'checked') {
      this.isValid[f.name] = f.field.checked;
    }

    if (!this.isSubmitting) {
      this.registrationFormBtn.disabled = !this.fields.every((f) => this.isValid[f.name]);
    }
  }

  initFormSubmit() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      this.submitFullForm();
    });
  }

  setSubmittingState(isSubmitting) {
    this.isSubmitting = isSubmitting;
    this.registrationFormBtn.disabled = isSubmitting;

    if (isSubmitting) {
      this.registrationFormBtn.textContent = 'Submitting...';
    } else {
      this.registrationFormBtn.textContent = this.originalButtonText;
    }
  }

  submitFullForm(newCode) {
    this.resetFormErrors();
    this.setSubmittingState(true);

    fetch(window.location.origin + '/apps/veeva-vault/v1/redemption/form-submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: this.form.elements['email'].value,
        first_name: this.form.elements['first-name'].value,
        last_name: this.form.elements['last-name'].value,
        employer: this.form.elements['employer'].value,
        job_title: this.form.elements['job-title'].value,
        region: this.form.elements['region'].value,
        phone: this.form.elements['phone'].value,
        registration_code: this.codes,
      }),
    })
      .then((response) => response.json())
      .then((data) => this.handleFormResponse(data))
      .catch((error) => {
        console.error('Error fetching app content:', error);
        this.setSubmittingState(false);
      });
  }

  handleFormResponse(data) {
    if (data.data.registration_code_errors) {
      if (data.data.registration_code_errors.data) {
        for (const property in data.data.registration_code_errors.data) {
          let htmlFieldName = property.replace('_', '-');
          this.validateField(htmlFieldName, data.data.registration_code_errors.data[property]);
        }
        this.setSubmittingState(false);
        return;
      }
    } else if (data.data) {
      for (const property in data.data) {
        if (data.data[property].success === 0) {
          this.codeError.innerHTML = data.data[property].data[0];
          this.setSubmittingState(false);
          return;
        }
      }
    }

    if (data.success !== 1) {
      this.setSubmittingState(false);
      return;
    }

    window.location.href = '/pages/thank-you';
  }

  validateField(name, errorText) {
    const field = this.form.elements[name];
    const errorElem = this.form.querySelector(`.${name}-error`);

    field.classList.add('invalid');
    errorElem.innerHTML = errorText;
  }

  resetFormErrors() {
    this.firstNameError.innerHTML = '';
    this.lastNameError.innerHTML = '';
    this.jobTitleError.innerHTML = '';
    this.employerError.innerHTML = '';
    this.phoneError.innerHTML = '';
    this.regionError.innerHTML = '';
    this.emailError.innerHTML = '';
    this.codeError.innerHTML = '';

    this.form.elements['first-name'].classList = '';
    this.form.elements['last-name'].classList = '';
    this.form.elements['job-title'].classList = '';
    this.form.elements['employer'].classList = '';
    this.form.elements['phone'].classList = '';
    this.form.elements['region'].classList = '';
    this.form.elements['email'].classList = '';
  }

  initSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);

    let urlCodes = searchParams.get('codes');
    this.codes = decodeURIComponent(urlCodes);

    this.fields.forEach((f) => {
      if (!searchParams.get(f.name) || searchParams.get(f.name) === 'null') return;
      this.form.elements[f.name].value = searchParams.get(f.name);
      this.handleFieldChange(f);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new RegistrationForm('#registration-form'));
